import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { updateUriRef } from '../../actions/filterActions';

// styles
import styles from './SbRespSortItems.scss';

function SbRespSortItemsComponent(props) {
    const { itemSearch, onChange } = props;
    const selectedValue = get(itemSearch, 'sort.currentOption.urlLabel');
    const options = itemSearch.sort.options.map(sortOption => {
        return {
            value: sortOption.urlLabel,
            label: sortOption.displayName,
        };
    });

    return (
        <div className={styles.container}>
            <BasicSelect
                size="medium"
                value={selectedValue}
                dataTn="sb-resp-sort-by"
                options={options}
                onChange={e => {
                    onChange(e.target.value);
                }}
            />
        </div>
    );
}

SbRespSortItemsComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

function mapDispatchToProps(dispatch, { itemSearch }) {
    return {
        onChange(value) {
            const filterValue = itemSearch.sort.options.find(option => option.urlLabel === value);
            dispatch(updateUriRef({ filterValue }));
        },
    };
}

export const SbRespSortItems = createFragmentContainer(
    connect(
        null,
        mapDispatchToProps
    )(SbRespSortItemsComponent),
    {
        itemSearch: graphql`
            fragment SbRespSortItems_itemSearch on ItemSearchQueryConnection {
                sort {
                    options {
                        urlLabel
                        linkReference
                        displayName
                    }
                    currentOption {
                        urlLabel
                    }
                }
            }
        `,
    }
);
